import { PropsWithChildren, useEffect, useRef } from 'react';
import {
  clearDiagramStore,
  createDiagramStore,
  DiagramState,
  DiagramStateProps,
  setDiagramStore,
} from './diagram.store';
import { DiagramStoreContext } from './store.context';
import { StoreApi } from 'zustand';

type DiagramStoreProviderProps = PropsWithChildren<DiagramStateProps>;

export const DiagramStoreProvider = ({
  children,
  ...props
}: DiagramStoreProviderProps) => {
  const storeRef = useRef<StoreApi<DiagramState>>();
  if (!storeRef.current) {
    storeRef.current = createDiagramStore(props);
  }
  setDiagramStore(storeRef.current);

  useEffect(() => clearDiagramStore(), []);

  return (
    <DiagramStoreContext.Provider value={storeRef.current}>
      {children}
    </DiagramStoreContext.Provider>
  );
};
